import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { FindMovimentoDto } from '@/api.types.extra';
import { GetUsuarios } from '@/modules/system/usuario/usuario.service';
import { LerMovimentacoes, textoCivelCriminal } from '../movimentacao.service';
import { Link } from 'react-router-dom';
import { ReadMovimentacaoDto, ReadUsuarioDto } from '@/api.types';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useEffect, useState } from 'react';

export default function PesquisaMovimentacoesPage() {
  const [idUsuario, setIdUsuario] = useState(0);
  const [loaded, setLoaded] = useState(false)
  const [buscando, setBuscando] = useState(false)

  const [listaUsuarios, setListaUsuarios] = useState<ReadUsuarioDto[]>([]);
  const [registros, setRegistros] = useState<[ReadMovimentacaoDto[], number]>();
  const tableState = useDataTableState('editadoEm');

  useEffect(() => {
    GetUsuarios({ skip: 0, take: 1000 })
      .then((result) => {
        const ordenados = result[0].sort((a, b) => a.username!.localeCompare(b.username!));
        setListaUsuarios(ordenados);
        if (ordenados.length > 0)
          setIdUsuario(ordenados[0].id);
      })
      .catch(console.warn)
      .finally(() => {
        setLoaded(true)
      })
  }, []);

  function handleBuscar() {
    if (loaded) {
      setBuscando(true)

      const filters: FindMovimentoDto = {
        skip: (tableState.currentPage - 1) * tableState.pageSize,
        take: tableState.pageSize,
        comDefensor: true,
        comLocal: true,
        comRegistros: false,
        editadoPor: idUsuario,
        orderField: tableState.sortConfig.key,
        orderDirection: tableState.sortConfig.direction
      }

      LerMovimentacoes(filters)
        .then((result) => {
          setRegistros(result);
        })
        .catch((res) => {
          toast.error(res)
        })
        .finally(() => {
          setBuscando(false)
        })
    }
  }

  useEffect(() => {
    handleBuscar();
  }, [loaded, idUsuario])

  let colunas: Column<ReadMovimentacaoDto>[] = [
    { key: "editadoEm", header: "Editado Em", render: (row) => format(new Date(row.editadoEm), "dd/MM/yyyy HH:mm", { locale: ptBR }) },
    { key: "referencia", header: "Referência", render: (row) => format(new Date(row.referencia), "dd/MM/yyyy HH:mm", { locale: ptBR }), invisible: true },
    { key: "data_recebimento", header: "Recebimento", render: (row) => format(new Date(row.data_recebimento), "dd/MM/yyyy HH:mm", { locale: ptBR }), invisible: true },
    { key: "defensor.nome", header: "Defensor" },
    { key: "defensoria.nome", header: "Local", render: (row) => (row.defensoria?.nome || row.nucleo?.nome) },
    { key: "observacao", header: "Observação", invisible: true },
    { key: "tipo", header: "Tipo", render: (row) => textoCivelCriminal(row.civel, row.criminal) },
    {
      key: "acoes", header: "Ações", render: (row) => {
        return (
          <Link className="link-secondary" to={Links.Movimentacoes_Editar + '/' + row.id + `?ehnucleo=${row.nucleo ? 'true' : 'false'}`} target='_blank'>
            Editar
          </Link >
        )
      }
    },
  ];

  return (
    <div className="row">
      <div className="col-md-8">
        <h3>Pesquisa de Atividades</h3>
      </div>
      <hr />

      <DataTable
        columns={colunas}
        data={registros?.[0]}
        initialSortKey="editadoEm"
        onChange={handleBuscar}
        serverSide={true}
        showFilter={false}
        states={tableState}
        totalRecords={registros?.[1]}
        renderFilters={() => (
          <div className='row'>
            <div className="col-md-10">
              <label htmlFor="editadoPor" className="col-form-label">Editado Por:</label>
              <select
                id="editadoPor"
                title="Editado Po"
                className="form-select"
                value={idUsuario}
                onChange={(e) => { setIdUsuario(Number(e.target.value)) }}
              >
                {listaUsuarios.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.username}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-2 mt-3 pt-4">
              <button className="btn btn-sm btn-outline-success" onClick={handleBuscar} disabled={buscando}>
                {buscando ? 'Buscando...' : 'Pesquisar'}
              </button>
            </div>
          </div>
        )}
      />
    </div>
  );
}
